/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankc": {
        "nested": {
          "BalanceInstrumentType": {
            "values": {
              "UNKNOWN_BALANCE_INSTRUMENT_TYPE_DO_NOT_USE": 0,
              "DIRECT_DEPOSIT_ACCOUNT": 1
            }
          },
          "BalanceInstrumentState": {
            "values": {
              "UNKNOWN_BALANCE_INSTRUMENT_STATE_DO_NOT_USE": 0,
              "INITIATED": 4,
              "ENABLED": 1,
              "SUSPENDED": 2,
              "TERMINATED": 3,
              "FAILED_TO_CREATE": 5
            }
          },
          "BalanceInstrument": {
            "fields": {
              "type": {
                "type": "squareup.bankc.BalanceInstrumentType",
                "id": 1,
                "rule": "optional"
              },
              "id": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "state": {
                "type": "squareup.bankc.BalanceInstrumentState",
                "id": 3,
                "rule": "optional"
              },
              "externalToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "standardFideliusToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              },
              "directDepositAccount": {
                "type": "squareup.bankc.BalanceInstrument.DirectDepositAccount",
                "id": 5
              }
            },
            "nested": {
              "DirectDepositAccount": {
                "fields": {
                  "routingNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accountNumber": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountNumberSuffix": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "instrument": {
                "oneof": ["directDepositAccount"]
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankc?.nested?.BalanceInstrumentType && !$root.nested?.squareup?.nested?.bankc?.nested?.BalanceInstrumentState && !$root.nested?.squareup?.nested?.bankc?.nested?.BalanceInstrument && !$root.nested?.squareup?.nested?.bankc?.nested?.BalanceInstrument?.nested?.DirectDepositAccount) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BalanceInstrumentType @ squareup/bankc/instruments.proto at 122:1
 */
export const BalanceInstrumentType = $root.lookupEnum('squareup.bankc.BalanceInstrumentType').values;
/**
 * SOURCE BalanceInstrumentState @ squareup/bankc/instruments.proto at 127:1
 */
export const BalanceInstrumentState = $root.lookupEnum('squareup.bankc.BalanceInstrumentState').values;
/**
 * Represents instruments that can operate on seller’s balance.
 *
 * SOURCE BalanceInstrument @ squareup/bankc/instruments.proto at 144:1
 */
export const BalanceInstrument = $root.lookupType('squareup.bankc.BalanceInstrument');
fixType(BalanceInstrument);
Builder.createAndAttachToType(BalanceInstrument);
/**
 * SOURCE DirectDepositAccount @ squareup/bankc/instruments.proto at 167:3
 */
BalanceInstrument.DirectDepositAccount = $root.lookupType('squareup.bankc.BalanceInstrument.DirectDepositAccount');
fixType(BalanceInstrument.DirectDepositAccount);
Builder.createAndAttachToType(BalanceInstrument.DirectDepositAccount);